interface IProps {
    children?: any,
}

export const ThemesTable = (props: IProps) => {
    return (
        <div className="table-responsive">
            <table className="table table-centered">
                <thead className="thead-light">
                    <tr>
                        <th>Název</th>

                        <th>Určení</th>
  
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {props.children}
                </tbody>
            </table>
        </div>)
}